import { IonContent, IonLoading, IonPage } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { user } from '../services/api.ts';

const OAuthSuccess: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');

        if (!token) {
          setError('Authentication failed: No token received');
          setLoading(false);
          return;
        }

        // Store the token
        localStorage.setItem('accessToken', token);

        // Verify token works by getting user profile
        try {
          await user.getProfile();
          // Redirect to the main app with a short delay to show success message
          setTimeout(() => {
            history.replace('/app/network');
          }, 1500);
        } catch (profileError) {
          console.error('Error validating token:', profileError);
          setError('Authentication failed: Invalid token');
          localStorage.removeItem('accessToken');
          setLoading(false);
        }
      } catch (e) {
        console.error('OAuth callback error:', e);
        setError('An unexpected error occurred');
        setLoading(false);
      }
    };

    handleOAuthCallback();
  }, [location, history]);

  return (
    <IonPage>
      <IonContent className="ion-padding">
        <div className="flex flex-col items-center justify-center min-h-screen">
          {error ? (
            <div className="p-6 bg-red-50 rounded-lg text-center max-w-md mx-auto shadow-md">
              <p className="text-red-600 mb-4">{error}</p>
              <button
                className="px-4 py-2 bg-blue-500 text-white rounded-lg"
                onClick={() => history.replace('/login')}
              >
                Return to Login
              </button>
            </div>
          ) : (
            <div className="p-6 bg-white rounded-lg text-center max-w-md mx-auto shadow-md">
              <div className="flex justify-center mb-4">
                <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
              <h2 className="text-2xl font-bold mb-2">Authentication Successful</h2>
              <p className="text-gray-600">You're now signed in with your Gmail account.</p>
              <p className="text-gray-600 mt-2">Redirecting to your dashboard...</p>
            </div>
          )}
        </div>
        <IonLoading isOpen={loading && !error} message={'Processing authentication...'} />
      </IonContent>
    </IonPage>
  );
};

export default OAuthSuccess;